import { Component, OnInit, Inject } from '@angular/core';
import { MatDialog, MatDialogRef, MAT_DIALOG_DATA } from '@angular/material';
import { ApiService } from '@angular/synthrone-design/services';
import { MessagesService } from '@angular/synthrone-design/services/messages/messages.service';

@Component({
  selector: 'platform-specification-editor',
  templateUrl: './platform-specification-editor.component.html',
  styleUrls: ['./platform-specification-editor.component.scss']
})
export class PlatformSpecificationEditor implements OnInit {


  dataParsed = [];
  sortOptions: any;

  optionsEditing = false;
  optionsEditingParent = null;
  optionsEditingArray = [];

  constructor(
    @Inject(MAT_DIALOG_DATA) public data: any,
    private messagesService: MessagesService,
    protected api: ApiService,
    public dialogRef: MatDialogRef<PlatformSpecificationEditor>,
    public dialog: MatDialog) { }

  ngOnInit() {
    const dataParsed = JSON.parse(this.data);

    this.sortOptions = {
      onUpdate: (event: any) => {
        this.addEmpty();
        this.removeEmpty();
      },
      handle: '.drag-handle'
    };

    this.dataParsed = [];

    for (let i = 0; i < dataParsed.length; i++) {
      this.addValue(dataParsed[i]);
    }
    this.addValue();

  }

  removeEmpty = () => {
    if (this.dataParsed.length > 1) {
      for (let i = 0; i <= this.dataParsed.length - 2; i++) {
        if (this.testFields(this.dataParsed, i) == "") {
          this.dataParsed.splice(i, 1);
        }
      }
    }
  }

  removeRow = (i) => {
    this.dataParsed.splice(i, 1);
    this.addValue();
    this.addEmpty();
    this.removeEmpty();
  }

  addEmpty = () => {
    if (this.testFields(this.dataParsed, this.dataParsed.length - 1) != "") {
      this.addValue();
    }
  }



  removeEmptyOption = () => {
    if (this.optionsEditingArray.length > 1) {
      for (let i = 0; i <= this.optionsEditingArray.length - 2; i++) {
        if (this.testFields(this.optionsEditingArray, i) == "") {
          this.optionsEditingArray.splice(i, 1);
        }
      }
    }
  }

  removeOptionRow = (i) => {
    this.optionsEditingArray.splice(i, 1);
    this.addOptionValue();
    this.addEmptyOption();
    this.removeEmptyOption();
  }

  addEmptyOption = () => {
    if (this.testFields(this.optionsEditingArray, this.optionsEditingArray.length - 1) != "") {
      this.addOptionValue();
    }
  }


  closeWindow = (param = null) => {
    this.dialogRef.close(param);
  }

  save = () => {
    let arrayOfValues = [];
    for (let i = 0; i <= this.dataParsed.length - 1; i++) {
      if (this.testFields(this.dataParsed, i) != "") {
        let toAdd = {};
        Object.keys(this.dataParsed[i]).forEach(oK => {
          if(this.dataParsed[i][oK] != "" && this.dataParsed[i][oK] != null){
            toAdd[oK] = this.dataParsed[i][oK];
          }
        })
        arrayOfValues.push(toAdd);
      }
    }
    let params = arrayOfValues.length > 0 ? JSON.stringify(arrayOfValues) : "";
    this.closeWindow(params)
  }



  endOptionsEdit = () => {
    
    let arrayOfValues = [];
    for (let i = 0; i <= this.optionsEditingArray.length - 1; i++) {
      if (this.testFields(this.optionsEditingArray, i) != "") {
        let toAdd = {};
        Object.keys(this.optionsEditingArray[i]).forEach(oK => {
          if(this.optionsEditingArray[i][oK] != "" && this.optionsEditingArray[i][oK] != null){
            toAdd[oK] = this.optionsEditingArray[i][oK];
          }
        })
        arrayOfValues.push(toAdd);
      }
    }
    this.optionsEditingParent['options'] = JSON.parse(JSON.stringify(arrayOfValues));
    this.optionsEditing = false;
    this.optionsEditingParent = null;
    this.optionsEditingArray = [];
  }

  setType = (row, type = '') => {
    if (row.type != type) {
      row.type = type;
      if (type == '') {
        row.options = null;
      } else {
        row.options = [];
      }
      this.addValue();
      this.addEmpty();
      this.removeEmpty();
    }
  }

  testFields = (dataToTest, i) => {
    const data = JSON.parse(JSON.stringify(dataToTest));
    let testField = (field) => {
      return Array.isArray(field) ? (field.length > 0 ? 1 : '') : (field ? field.trim() : '');
    }
    return Object.keys(data[i]).map(tK => data[i][tK]).reduce((a = "", b) => {
      return testField(a) + testField(b)
    })
  }
  isJsonString(str) {
    try {
      JSON.parse(str);
    } catch (e) {
      return false;
    }
    return str ? true : false;
  }

  editOptions = (dataToEdit) => {
    this.optionsEditingParent = dataToEdit;
    this.optionsEditingArray = []

    for (let i = 0; i < dataToEdit['options'].length; i++) {
      this.addOptionValue(dataToEdit['options'][i]);
    }
    this.addOptionValue();
    this.optionsEditing = true;
  }

  private addValue = (passedObject = {}) => {
    this.dataParsed.push(Object.assign({}, {
      key: "",
      name: "",
      placeholder: "",
      type: "",
      options: null
    }, passedObject));
  }

  private addOptionValue = (passedObject = {}) => {
    this.optionsEditingArray.push(Object.assign({}, {
      value: "",
      name: ""
    }, passedObject));
  }



}



// WEBPACK FOOTER //
// ./src/app/components/forms/platform-specification-editor/platform-specification-editor.component.ts